import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../../helpers/request.helpers";

export type Response = {
  UserId: number;
  TicketUpdates: TicketUpdate[];
};

export type TicketUpdate = {
  TicketID: number;
  MessageID: number;
  Sender: string;
  Body: string;
  LastMessageIDSeen: number;
};

export function useUpdatesForUser() {
  return useQuery({
    queryKey: ["updates-for-user"],
    queryFn: async () => {
      const data: Response = await apiGet("/tickets/list-updates-for-user");
      return data.TicketUpdates;
    },
    refetchOnWindowFocus: "always",
    refetchInterval: 1000 * 60,
  });
}
